var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.current_doc_type == 5)?_c('receipt-print'):_vm._e(),(_vm.current_doc_type == 7)?_c('cert-of-completion-print'):_vm._e(),(_vm.current_doc_type == 4)?_c('act-reconciliation'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }